// export const API_ROOT = 'https://api-dev.inherinext.compassbioinfo.com/'
export const API_ROOT = 'https://api-local-dev.inherinext.compassbioinfo.com/'
// export const API_ROOT = 'https://server.inherinext.com/'



// WEBPACK FOOTER //
// ./src/api/config.js